import {
  ShipmentDocument,
  ShipmentDocumentItem,
} from './shipment-document.model';

export interface CreateDockLog {
  dockLogId?: string;
  facilityKeyId: number;
  dockLogDescription: string;
  shipmentDocument: ShipmentDocument;
  shipmentDocumentItems: ShipmentDocumentItem[];
}

export interface DockLog {
  dockLogId: string;
  receiveDate: string;
  purchaseOrderNumber: string;
  dockLogDescription: string;
  vendorId: string;
  vendorName: string;
  carrierId: string;
  carrierName: string;
  containerName: string;
  itemCode: string;
  itemId: string;
  itemTypeId: string;
  itemTypeName: string;
  itemDescription: string;
  packingSlip: string;
  warehouseId: string;
  warehouseName: string;
  sublocationId: string;
  sublocationName: string;
  shipmentDocumentId: string;
  shipmentDocumentItemId: string;
  shipmentDocumentItemStatusId: string;
  shipmentDocumentItemStatusName: string;
  quantity?: number;
  notes?: string;
  requisitionNotes: string[];
  requisitionId?: string;
  requisitionItemId?: string;
}

export interface MaterialWarehouseDto {
  facilityId?: number;
  warehouseName?: string;
  warehouseId?: string;
}

export interface SublocationDto {
  sublocationName?: string;
  warehouseId?: string;
  isFinalLocation?: boolean;
}
